






















































import { Component, Vue } from 'vue-property-decorator'
import { UserStoreMod } from '../store/user-store'
import { VendorEvent, eventStore } from '../store/event-store'

@Component
export default class EventListPage extends Vue {
  newEventTitle = ''
  newEventLocation = ''

  get events () {
    return eventStore.events
  }

  openNewEventPopup () {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.$f7!.popup.open('#new-event-popup')
  }

  async addNewEvent (newEventTitle: string, newEventLocation: string) {
    const newEvent: VendorEvent = {
      title: newEventTitle,
      location: newEventLocation,
      vendorId: UserStoreMod.vendorId,
      menu: []
    }

    await eventStore.addEvent(newEvent)

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.$f7!.popup.close('#new-event-popup')
    this.newEventTitle = ''
  }
}
